
import shortid from 'shortid'

import iterateWorker from 'workerize-loader!./worker' // eslint-disable-line import/no-webpack-loader-syntax

export default class Lerp {
  constructor () {
    this.worker = iterateWorker()
    this.worker.addEventListener('error', (message) => console.log(message))
    this.iterationId = shortid()
    this.callbackFn = () => {}
  }

  setEdgePositionFrom (array) {
    this.from = array
  }

  setEdgePositionTo (array) {
    this.to = array
  }

  setEdgeIndexes (array) {
    this.edgeIndexes = array
  }

  run = (
    factor = 0.5,
    iterationId,
    nodeLength,
    edgeLength,

    callback
  ) => {
    this.worker.removeEventListener('message', this.callbackFn)

    this.callbackFn = (message) => {
      if (message.data.result) {
        callback(message.data.result)
      }
    }
    this.worker.addEventListener('message', this.callbackFn)

    if (this.from && this.to && this.edgeIndexes) {
      this.worker.run(
        iterationId,
        this.from,
        this.to,
        this.edgeIndexes,
        factor
      )
    } else {
      callback(null)
    }
  }
}
